export default __webpack_public_path__ + "static/media/staff-id-card-1.9c16aa89.jpg";